 
 export const GetServices = async (regnum) => {
    return fetch(`api/General/GetServices/`)
       .then(handleResponse)

       .then(response => response.json())

}
export const LogOut = async () => {
    return fetch(`api/login/logout/`)
       .then(handleResponse)

       .then( )

}
 export const GetStudentName = async (regnum) => {
     return fetch(`api/General/GetStudentName/${regnum}`)
        .then(handleResponse)

        .then(response => response.json())

}
export const GetLastTermCourses = async () => {
    return fetch('api/Results/GetLastTermCourses')
       .then(handleResponse)

       .then(response => response.json())

}
const handleResponse = (response) => {

    if (!response.ok) {
        if (response.status === 401) {
            // auto logout if 401 response returned from api
            console.log(this.props)
            window.location = "http://www.google.com"
        }


        return Promise.reject();
    }
    return Promise.resolve(response)


}




// WEBPACK FOOTER //
// ./src/GeneralAPI.js